import '../global.css';
import './auth-theme.css';

import {
  Button,
  createTheme,
  CSSVariablesResolver,
  Input,
  LoadingOverlay,
  MantineColorsTuple,
  Modal,
  PasswordInput,
  TextInput,
} from '@mantine/core';

const primaryColor: MantineColorsTuple = [
  '#E3F6FF',
  '#CEE7FF',
  '#9FCDFB',
  '#6CB1F7',
  '#4299F2',
  '#278AF0',
  '#2086F0',
  '#0070D7',
  '#0063C2',
  '#0055AC',
];

export const theme = createTheme({
  defaultRadius: 'md',
  components: {
    Button: Button.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    TextInput: TextInput.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    PasswordInput: PasswordInput.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    Input: Input.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    InputWrapper: Input.Wrapper.extend({
      defaultProps: {
        size: 'lg',
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        overlayProps: { backgroundOpacity: 0.4, blur: 15 },
        transitionProps: { duration: 300 },
        zIndex: 5000,
      },
    }),
    LoadingOverlay: LoadingOverlay.extend({
      defaultProps: {
        overlayProps: { radius: 'sm', blur: 2, bg: 'transparent' },
      },
    }),
  },
  primaryColor: 'primary',
  colors: {
    primary: primaryColor,
  },
  cursorType: 'pointer',
});

export const resolver: CSSVariablesResolver = (theme) => ({
  variables: {
    '--snappea-color-body': '#FFFFFF',
    '--snappea-color-text': '#222222',
    '--snappea-font-size-text': theme.fontSizes.md,
  },
  light: {},
  dark: {},
});
